import { render, staticRenderFns } from "./EditarCursoProgramadoFormComponent.vue?vue&type=template&id=5e6d2652"
import script from "./EditarCursoProgramadoFormComponent.vue?vue&type=script&lang=js"
export * from "./EditarCursoProgramadoFormComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports